import { render } from "./ProposalsChart.vue?vue&type=template&id=4861a178"
import script from "./ProposalsChart.vue?vue&type=script&lang=js"
export * from "./ProposalsChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__